import { render, staticRenderFns } from "./CompositionNav.vue?vue&type=template&id=408a4d27&"
import script from "./CompositionNav.vue?vue&type=script&lang=js&"
export * from "./CompositionNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports